export const getCountDiff = (prev: number, next: number) => Math.abs(next - prev);
